const columns = [
    { id: 'id', label: 'ID игры'},
    { id: 'name', label: 'Название игры'},
    { id: 'bet', label: 'Количество'},
    { id: 'sum_bet', label: 'Сумма ставок'},
    { id: 'sum_win', label: 'Сумма выигрышей'},
    { id: 'difference', label: 'Разница'},
    { id: 'rtp', label: 'Среднее RTP (%)'},
];

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.uuid,
            name: item.game,
            bet: item.count, 
            sum_bet: new Intl.NumberFormat('ru-RU').format(item.sum) + '₽',
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win) + '₽',
            difference: new Intl.NumberFormat('ru-RU').format(+item.sum - +item.sum_win) + '₽',
            rtp: (item.sum_win / item.sum * 100).toFixed(0) + '%'
        }
    })
} 

export {
    columns,
    getRows
}